var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightOrangePlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.0001C17.5228 22.0001 22 17.5229 22 12.0001C22 6.47725 17.5228 2.0001 12 2.0001C6.47715 2.0001 2 6.47725 2 12.0001C2 17.5229 6.47715 22.0001 12 22.0001ZM13.25 8.2501C13.25 7.55974 12.6904 7.0001 12 7.0001C11.3096 7.0001 10.75 7.55974 10.75 8.2501V10.7501H8.25C7.55964 10.7501 7 11.3097 7 12.0001C7 12.6905 7.55964 13.2501 8.25 13.2501H10.75V15.7501C10.75 16.4405 11.3096 17.0001 12 17.0001C12.6904 17.0001 13.25 16.4405 13.25 15.7501V13.2501H15.75C16.4404 13.2501 17 12.6905 17 12.0001C17 11.3097 16.4404 10.7501 15.75 10.7501H13.25V8.2501Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightOrangePlus);
export default __webpack_public_path__ + "static/media/light-orange-plus.7fd71406ceca9eb2558d59bff7840fa4.svg";
export { ForwardRef as ReactComponent };